import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="py-24 md:py-32 relative overflow-hidden">
      {/* Background video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="none"
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/assets/cta-bg.mp4" type="video/mp4" />
      </video>
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Noise overlay */}
      <div className="absolute inset-0 noise-overlay" />

      <div className="container mx-auto px-6 md:px-12 max-w-[1400px] relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <h2
            className="font-syne text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-8 max-w-[800px] mx-auto"
            data-testid="cta-heading"
          >
            Ready to Transform Your Brand?
          </h2>
          <p className="text-base md:text-lg font-light text-white/70 mb-12 max-w-[500px] mx-auto">
            Let's collaborate and create something extraordinary together.
          </p>
          <a
            href="#contact"
            data-testid="cta-start-project-button"
            className="inline-flex items-center gap-3 bg-white text-black font-bold rounded-full px-10 py-5 text-lg transition-transform hover:scale-105 active:scale-95 group"
          >
            Start Your Project
            <ArrowRight
              size={20}
              className="transition-transform group-hover:translate-x-1"
            />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
